export default __webpack_public_path__ + "3e4b4bb74d3fff1dd3f25322695cff8a.svg";